export enum ETokenType {
  registerEmail = 1,
  registerPhone = 2,
  changeEmail = 3,
  verifyEmail = 4,
  resetPassword = 5,
  registerTempUser = 6,
}
